import { render, staticRenderFns } from "./SearchViewBlock.vue?vue&type=template&id=dca312e8&scoped=true&"
import script from "./SearchViewBlock.vue?vue&type=script&lang=js&"
export * from "./SearchViewBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchViewBlock.vue?vue&type=style&index=0&id=dca312e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca312e8",
  null
  
)

export default component.exports